<template>
  <section class="contact">
    <article class="article">
      <section class="article-inner">
        <div class="contact-map"></div>
        <div class="contact-info">
          <h4>联系我们</h4>
          <p>电话：021-64480221</p>
          <p>地址：上海市闵行区田林路1036号科技绿洲三期16号楼4楼</p>
        </div>
      </section>
    </article>
  </section>
</template>

<script>
import zmBanner  from '@/components/Banner.vue'
export default {
  components: {
    zmBanner
  },
  props: {},
  data () {
    return {  
      vipList: ['用户在支付一定会员服务费用后可享受本站会员服务。', 
      '会员有效期内可重复购买会员服务，购买成功后，同种类型会员服务有效期将在原有基础上顺延。',
      '以“年”为单位的会员服务，按照每年365天计算会员有效期。',
      '会员服务过期后，未购买的定制数据报告需要重新购买或续费会员后才能继续享受定制服务。'],
      notice: ['如若恶意注册、作弊阅读、盗用或冒用他人信息注册将被取消会员资格。']
    }
  }
}
</script>
<style scoped>
.article {
  width: 1024px;
  padding: 50px 0; 
  margin: 50px auto 0;
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, .05);
  background-color: #fff;
}
.article-title {
  font-size: 24px;
  text-align: center;
}
.article-desc {
  margin: 30px 0;
  font-size: 18px;
  text-align: center;
}
.article-desc > span {
  font-size: 36px;
  color: #ee2929;
}
.article-desc > span:first-child {
  font-size: 30px;
}
.article-inner {
  width: 924px;
  margin: 0 auto;
  color: #222;
  line-height: 30px;
  overflow: hidden;
}
.contact-map {
  width: 550px;
  height: 380px;
  background-image: url('../assets/map.png');
  float: left;
  margin-right: 30px;
}
.contact-info {
  padding: 30px 0;
}
.contact-info > h4, .contact-info > p {
  margin-bottom: 20px;
}
</style>